import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Group = Loadable(lazy(() => import('./Group')));

const GroupRoutes = [
	{
		path: '/group',
		element: <Group />,
		auth: authRoles.admin,
	},
];

export default GroupRoutes;
